import { Actions } from './mobile-tasks.actions'
import { fromJS } from 'immutable'
import * as UsersTypes from './mobile-tasks.types'

export const initialState = fromJS({
  list: {
    isLoading: false,
    shouldReload: false,
    filters: [],
    pagination: {
      page: 1,
      page_size: 20,
    },
    data: [],
    total: 0,
    filtered: 0,
  },
  autoAssignTasks: {
    isLoading: false,
    assignedTaskCount: null,
  },
})

export function mobileTasksReducer(state = initialState, action: Actions) {
  switch (action.type) {
    case UsersTypes.FETCH_MOBILE_TASKS_REQUEST: {
      return state
        .setIn(['list', 'isLoading'], true)
        .setIn(['list', 'shouldReload'], false)
    }

    case UsersTypes.FETCH_MOBILE_TASKS_SUCCESS: {
      return state
        .setIn(['list', 'isLoading'], false)
        .setIn(['list', 'data'], fromJS(action.payload))
        .setIn(['list', 'total'], action.total)
        .setIn(['list', 'filtered'], action.filtered)
    }

    case UsersTypes.FETCH_MOBILE_TASKS_FAILURE: {
      return state.setIn(['autoAssignTasks', 'isLoading'], false)
    }

    case UsersTypes.AUTOASSIGN_TASKS_REQUEST: {
      return state
        .setIn(['autoAssignTasks', 'isLoading'], true)
        .setIn(['list', 'shouldReload'], false)
        .setIn(['autoAssignTasks', 'assignedTaskCount'], null)
    }

    case UsersTypes.AUTOASSIGN_TASKS_SUCCESS: {
      return state
        .setIn(['autoAssignTasks', 'isLoading'], false)
        .setIn(['list', 'shouldReload'], true)
        .setIn(
          ['autoAssignTasks', 'assignedTaskCount'],
          action.payload.assignedTaskCount,
        )
    }

    case UsersTypes.AUTOASSIGN_TASKS_FAILURE: {
      return state.setIn(['autoAssignTasks', 'isLoading'], false)
    }

    case UsersTypes.UPDATE_FIELD:
      let fields = []

      if (action.path === '') {
        fields = action.field.split('.')
      } else {
        fields = action.path.split('.').concat(action.field.split('.'))
      }
      const value = action.value

      if (fields.length === 1) {
        return state.set(fields[0], fromJS(value))
      }
      return state.setIn(fields, fromJS(value))
    case UsersTypes.SET_DEFAULT_DATA:
      const path = action.path || ''
      return state.setIn(path.split('.'), initialState.getIn(path.split('.')))

    default:
      return state
  }
}
